import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "../../hooks/useTheme";
import { IRadio } from "./types";

type IProps = IRadio & JSX.IntrinsicElements["input"];

export const Radio = React.forwardRef<HTMLInputElement, IProps>(
  ({ label, name, value, disabled, dimension = 20, ...rest }, ref) => {
    const { colors } = useTheme();
    const { css } = useFela();

    return (
      <label
        className={css({
          cursor: disabled ? "not-allowed" : "pointer",
          nested: {
            ":hover input:not(:disabled)": {
              nested: {
                "& + span::before": {
                  transform: "scale(.92)",
                },
                "& + span::after": {
                  transform: "scale(.74)",
                },
                "&:checked + span::after": {
                  transform: "scale(.6)",
                },
              },
            },
          },
        })}
      >
        <input
          ref={ref}
          type="radio"
          name={name}
          value={value}
          disabled={disabled}
          className={css({
            display: "none",
            nested: {
              "&:disabled + span": {
                color: colors.LIGHT_GRAY,
              },
              "&:checked + span::before": {
                backgroundColor: colors.ORANGE,
              },
              "&:checked + span::after": {
                transform: "scale(.6)",
                transition: "transform .3s ease",
              },
            },
          })}
          {...rest}
        />
        <span
          className={css({
            display: "inline-block",
            position: "relative",
            lineHeight: `${dimension}px`,
            paddingLeft: dimension,
            nested: {
              "::before": {
                content: "''",
                width: dimension,
                height: dimension,
                display: "block",
                position: "absolute",
                left: 0,
                top: 0,
                borderRadius: "50%",
                backgroundColor: colors.STARDUST,
                transition:
                  "background-color .2s ease, transform .4s cubic-bezier(.175, .885, .32, 2)",
              },
              "::after": {
                content: "''",
                width: dimension,
                height: dimension,
                display: "block",
                position: "absolute",
                left: 0,
                top: 0,
                borderRadius: "50%",
                backgroundColor: colors.WHITE,
                transform: "scale(.78)",
                transition: "transform .6s cubic-bezier(.175, .885, .32, 1.4)",
              },
              "&:not(:empty)": {
                paddingLeft: dimension + 10,
              },
            },
          })}
        >
          {label}
        </span>
      </label>
    );
  },
);
